




























import {
  defineComponent,
  useStatic,
  useMeta,
  ref,
  useContext,
} from '@nuxtjs/composition-api'

export default defineComponent({
  setup() {
    const tab = ref(0)
    const { $content } = useContext()

    const pages = useStatic(
      async () => {
        const [kontakt, mitarbeiter, mitglieder, teilnehmer, website] =
          await Promise.all([
            $content('datenschutz/kontakt').fetch(),
            $content('datenschutz/mitarbeiter').fetch(),
            $content('datenschutz/mitglieder').fetch(),
            $content('datenschutz/teilnehmer').fetch(),
            $content('datenschutz/website').fetch(),
          ])

        return {
          kontakt,
          mitarbeiter,
          mitglieder,
          teilnehmer,
          website,
        }
      },
      undefined,
      'datenschutz',
    )

    return {
      tab,
      pages,
    }
  },
  head: {
    title: 'Datenschutz',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: 'Unsere Datenschutzerklärung für alle Personengruppen.',
      },
      // Open Graph
      { hid: 'og:title', property: 'og:title', content: 'Datenschutz' },
      {
        hid: 'og:description',
        property: 'og:description',
        content: 'Unsere Datenschutzerklärung für alle Personengruppen.',
      },
      // Twitter Card
      { hid: 'twitter:title', name: 'twitter:title', content: 'Datenschutz' },
      {
        hid: 'twitter:description',
        name: 'twitter:description',
        content: 'Unsere Datenschutzerklärung für alle Personengruppen.',
      },
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.ec-nordbund.de/datenschutz',
        hid: 'canonical',
      },
    ],
  },
})
